














































import {
  computed,
  defineComponent,
  PropType,
  useContext,
  ref
} from '@nuxtjs/composition-api';
import { getCustomFieldByKey } from '~/helpers/utils';
/* @ts-ignore */
import fallbackImage from '@/assets/images/Kamera_Express_faded_logo.webp';

export type BasicBanner = {
  id: number;
  code: string;
  number_of_columns: number;
  urls: Array<{
    url: string;
    media_path: string;
    media_file_name: string;
  }>;
  data_attributes?: Array<{ key: string; value: string }>;
  custom_fields: Array<
    | { key: 'title'; value_string: string }
    | { key: 'subtitle'; value_string: string }
    | { key: 'text_color'; value_select: 'white' | 'black' }
    | { key: 'button_text'; value_string: string }
  >;
};

export default defineComponent({
  name: 'BasicBanner',
  props: {
    data: {
      type: Object as PropType<BasicBanner>,
      required: true
    }
  },
  setup(props) {
    const { $config } = useContext();
    const helperErrored = ref(false);

    const isSmallCard = computed(() => props.data.number_of_columns === 6);

    const subtitleClass = computed(() =>
      props.data.number_of_columns === 12 ? 'full-width-subtitle' : ''
    );

    const urlData = computed(() => props.data.urls[0]);
    const bannerId = computed(() => props.data.id);

    const textColor = () =>
      getCustomFieldByKey(props.data.custom_fields, 'text_color')?.value_select;

    const getField = (field: string) =>
      getCustomFieldByKey(props.data.custom_fields, field)?.value_string;

    const getDataAttributes = (banner: any) =>
      (banner.data_attributes || []).reduce(
        (acc, { key, value }) => ({ ...acc, [key]: value }),
        {} as Record<string, string>
      );

    const mediaUrl = (path: string) =>
      path.includes('https://') ? path : `${$config.mediaBaseURL}${path}`;

    const imageSrc = computed(() => {
      const p = props.data.urls[0]?.media_path;
      if (!p || p === '/' || helperErrored.value) return fallbackImage;
      return mediaUrl(p);
    });

    const onHelperError = () => (helperErrored.value = true);

    const wrapperStyle = computed(() => ({
      backgroundImage: `url('${imageSrc.value}')`
    }));

    return {
      isSmallCard,
      subtitleClass,
      urlData,
      bannerId,
      textColor,
      getField,
      getDataAttributes,
      imageSrc,
      onHelperError,
      wrapperStyle
    };
  }
});
